$(document).ready(function(){
  $(".bc-sf-filter-block-content,.bc-sf-filter-option-view-more,.bc-sf-filter-option-view-less").hide();
  //if ($('window').width() < 769) {
    //$('#bc-sf-filter-wrapper .bc-sf-filter-default-toolbar-inner.sort').hide();
    //$('#bc-sf-filter-wrapper .bc-sf-filter-default-toolbar-inner.filter').hide();
  //}
  
  $('.the-nav').cbFlyout();

  $('#sort-by').on('click', function() {
    $('body').toggleClass('sort-active');
  });

  $('#filter-by').on('click', function() {
    $('body').toggleClass('filter-active');
  });
  
  $("#sort-by").on("click",function(e){
    if ($("window").width() < 769) {
      e.preventDefault();
      e.stopPropagation();

      $(".filter").hide();
      $(".sort").show();
      
    }
  });
  $("#filter-by").on("click",function(f){
    if ($("window").width() < 769) {
      f.preventDefault();
      f.stopPropagation();

      $(".sort").hide();
      $(".filter").show();
    }
  });

  //Filter accordion
  $(document).on("click",".bc-sf-filter-block-title",function(){
    const parent = $(this).parent()
    parent.toggleClass("active")
    if(parent.find(".bc-sf-filter-block-content").is(":visible")) {
      parent.find(".bc-sf-filter-option-view-more").hide()
      parent.find(".bc-sf-filter-option-view-less").hide()
    } else {
      parent.find(".bc-sf-filter-option-view-more").show()
      parent.find(".bc-sf-filter-option-view-less").show()
    }
    parent.find(".bc-sf-filter-block-content").slideToggle(200)

  })
//   $("html,body").on("click",'#bc-sf-filter-options-wrapper .bc-sf-filter-option-block',function(){
// //     alert(123);
//     $(".bc-sf-filter-block-content,.bc-sf-filter-option-view-more,.bc-sf-filter-option-view-less").hide();
//     if($(this).find(".bc-sf-filter-block-content").is(":visible")){
//       $(this).find(".bc-sf-filter-block-content,.bc-sf-filter-option-view-more,.bc-sf-filter-option-view-less").hide();
//     }else{
//       $(this).find(".bc-sf-filter-block-content,.bc-sf-filter-option-view-more,.bc-sf-filter-option-view-less").show();
//     }
//   })

  
    $(".ymal-product-container:not(.ymal-product-container-cart)").slick({
      infinite: true,
      slidesToShow: 2,
      adaptiveHeight: false,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1
        }
      }
    ]
    })
  $(".ymal-product-container-cart").slick({
      infinite: true,
      slidesToShow: 1,
      adaptiveHeight: false
    })
});
$(document).on("click",'.ymal-next',function(){
  $(this).closest(".ymal-container").find(".slick-initialized").slick("slickNext")
})
$(document).on("click",".ymal-prev",function() {
  $(this).closest(".ymal-container").find(".slick-initialized").slick("slickPrev")
})